<template>
    <div class="widget-new-product">
        <div class="widget__bg">
            <UiImage :src="__settings.widgetProductImage[0].url" :alt="__settings.widgetProductImage[0].title" />
        </div>
        <div class="widget__content">
            <NuxtLink
                :title="__settings.widgetProductLink[0].linkText"
                :to="convertLinkType(__settings.widgetProductLink[0])"
                class="link"
            >
                {{ __settings.widgetProductLink[0].linkText }}
            </NuxtLink>
        </div>
    </div>
</template>

<script setup>
    const globalStore = useGlobalStore();
    const { settings } = storeToRefs(globalStore);
    const __settings = computed(() => (!!settings.value.length ? settings.value[0] : []));
</script>
